import videoFeedTypes from './videoFeedTypes';

const { REEL } = videoFeedTypes;

const getMediaPath = (mediaObject = {}) => {

    //When useShareStore first run it return null
    if (mediaObject === null) {

        return '';

    }

    const { slug, feeds } = mediaObject;
    const mediaType = feeds && feeds[0]?.type;

    if (!slug || !mediaType) {

        return '';

    }

    let path = slug;

    if (mediaType === REEL) {

        const [
            userId,
            contentId,
        ] = slug.split('/');

        path = `${userId}/reels/${contentId}`;

    }

    return path;

};

export default getMediaPath;
